import { useState } from 'react';
import { ChargesTab } from './Charges';
import { InvoicesTab } from './Invoices';
import { useT } from '@/i18n/LanguageContext';

type Tab = 'invoices' | 'charges';

export function BillingPage(): JSX.Element {
  const [tab, setTab] = useState<Tab>('invoices');
  const t = useT();

  return (
    <div>
      <div className="page-header">
        <h1>{t('nav.billing')}</h1>
      </div>
      <div className="tabs">
        <button type="button" className={tab === 'invoices' ? 'active' : ''} onClick={() => setTab('invoices')}>
          {t('billingPage.invoices')}
        </button>
        <button type="button" className={tab === 'charges' ? 'active' : ''} onClick={() => setTab('charges')}>
          {t('billingPage.charges')}
        </button>
      </div>
      {tab === 'invoices' ? <InvoicesTab /> : <ChargesTab />}
    </div>
  );
}
